// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrafficconfigAzurePrivateEndpointConnection } from './TrafficconfigAzurePrivateEndpointConnection';
import {
  TrafficconfigAzurePrivateEndpointConnectionFromJSON,
  TrafficconfigAzurePrivateEndpointConnectionFromJSONTyped,
  TrafficconfigAzurePrivateEndpointConnectionToJSON,
  TrafficconfigAzurePrivateEndpointConnectionToJSONTyped,
} from './TrafficconfigAzurePrivateEndpointConnection';

/**
 *
 * @export
 * @interface TrafficconfigAzureStatus
 */
export interface TrafficconfigAzureStatus {
  /**
   *
   * @type {Array<TrafficconfigAzurePrivateEndpointConnection>}
   * @memberof TrafficconfigAzureStatus
   */
  privateEndpointConnections?: Array<TrafficconfigAzurePrivateEndpointConnection>;
  /**
   *
   * @type {string}
   * @memberof TrafficconfigAzureStatus
   */
  privatelinkServiceName?: string;
}

/**
 * Check if a given object implements the TrafficconfigAzureStatus interface.
 */
export function instanceOfTrafficconfigAzureStatus(
  value: object,
): value is TrafficconfigAzureStatus {
  return true;
}

export function TrafficconfigAzureStatusFromJSON(
  json: any,
): TrafficconfigAzureStatus {
  return TrafficconfigAzureStatusFromJSONTyped(json, false);
}

export function TrafficconfigAzureStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigAzureStatus {
  if (json == null) {
    return json;
  }
  return {
    privateEndpointConnections:
      json['private_endpoint_connections'] == null
        ? undefined
        : (json['private_endpoint_connections'] as Array<any>).map(
            TrafficconfigAzurePrivateEndpointConnectionFromJSON,
          ),
    privatelinkServiceName:
      json['privatelink_service_name'] == null
        ? undefined
        : json['privatelink_service_name'],
  };
}

export function TrafficconfigAzureStatusToJSON(
  json: any,
): TrafficconfigAzureStatus {
  return TrafficconfigAzureStatusToJSONTyped(json, false);
}

export function TrafficconfigAzureStatusToJSONTyped(
  value?: TrafficconfigAzureStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    private_endpoint_connections:
      value['privateEndpointConnections'] == null
        ? undefined
        : (value['privateEndpointConnections'] as Array<any>).map(
            TrafficconfigAzurePrivateEndpointConnectionToJSON,
          ),
    privatelink_service_name: value['privatelinkServiceName'],
  };
}
